import { CREATE_REFRESH_TOKEN, getTspRefreshToken, CREATE_TSP_TOKEN, getToken, getPlatformForSms } from "apps/login/util/mutations";
import { useMutation } from "@apollo/react-hooks";
import { SEND_CODE_FAILED_ERROR_MESSAGE } from "shared/constants/sms";

const useValidateCode = () => {
	const [createTspToken] = useMutation(CREATE_TSP_TOKEN);
	const [createRefreshToken, createRefreshTokenResult] = useMutation(CREATE_REFRESH_TOKEN);

	const validateCode = ({ phoneNumber, code }) => {
		if (!phoneNumber || !code) {
			return Promise.reject(new Error("Missing required param"));
		}

		return createTspToken()
			.then((res) => {
				const tspAccessToken = getToken(res);

				if (!tspAccessToken) {
					return Promise.reject(new Error(SEND_CODE_FAILED_ERROR_MESSAGE));
				}

				return tspAccessToken;
			}).then((tspAccessToken) => {
				const refreshTokenInput = {
					tspAccessToken,
					phoneNumber,
					otp: code,
					platform: getPlatformForSms(),
				};

				return createRefreshToken({
					variables: {
						input: refreshTokenInput,
					},
				})
					.then((res) => {
						const tspRefreshToken = getTspRefreshToken(res);

						if (!tspRefreshToken) {
							return Promise.reject(res.errors);
						}

						return tspRefreshToken;
					});
			});
	};

	return { validateCode, createRefreshTokenResult };
};

export default useValidateCode;



// WEBPACK FOOTER //
// ./src/shared/hooks/useValidateCode.js